// Service page content for Overseas Student Health Cover (OSHC).
// COMPLIANCE: arranging OSHC (the applicant's health product) is genuinely our
// lane; keep it confident. "Insurance" here means the applicant's OSHC, which is
// fine. The visa is lodged by a registered migration agent. Factual, overview
// level; no guarantees; no invented prices.

const oshc = {
  groupSlug: "student-graduate",
  slug: "oshc",
  title: "Overseas Student Health Cover (OSHC)",
  eyebrow: "Student & Graduate",
  intro:
    "Overseas Student Health Cover is the health insurance that student visa holders must hold for the full length of their visa. It is a condition of the student visa, not an optional extra. We help you arrange the right cover so this part of your application is never the thing that holds you up.",

  chips: [
    { label: "What it is", value: "Student health insurance" },
    { label: "Required by", value: "Student visa condition 8501" },
    { label: "Covers", value: "The full visa period" },
    { label: "We help", value: "Arrange a suitable policy" },
  ],

  whoFor: [
    "Student visa applicants who need cover in place to lodge.",
    "Students adding family members to their visa.",
    "People who want OSHC sorted alongside their visa, not as an afterthought.",
  ],

  essentials: [
    {
      title: "It is mandatory",
      detail:
        "Holding OSHC for the duration of your visa is a student visa condition. Letting it lapse can breach your visa.",
    },
    {
      title: "Cover for the full period",
      detail:
        "Your policy generally must cover the entire length of your student visa, not just your course dates.",
    },
    {
      title: "Family members included",
      detail:
        "If family members are on your visa, they usually need to be covered too.",
    },
    {
      title: "What it covers",
      detail:
        "OSHC helps with the cost of medical and hospital care while you study in Australia, within the policy terms.",
    },
    {
      title: "Choose a registered provider",
      detail:
        "Cover must be with an approved OSHC provider. We help you choose a suitable one.",
    },
    {
      title: "Keep it current",
      detail:
        "If you extend your studies, your cover needs to extend too. We help you keep it aligned with your visa.",
    },
  ],

  process: [
    {
      title: "Work out what you need",
      detail:
        "We confirm the cover length and whether family members need to be included.",
    },
    {
      title: "Compare suitable policies",
      detail:
        "We help you choose an approved OSHC policy that fits your visa and budget.",
    },
    {
      title: "Arrange the cover",
      detail:
        "We help you put the policy in place so it is ready for your visa application.",
    },
    {
      title: "Add the evidence to your file",
      detail:
        "We organise your OSHC evidence into your file for the student visa application a registered migration agent lodges.",
    },
    {
      title: "Keep it aligned",
      detail:
        "If your studies change or extend, we help you keep your cover current.",
    },
  ],

  faqs: [
    {
      q: "Do I really have to have OSHC?",
      a: "Yes. It is a condition of the student visa that you hold Overseas Student Health Cover for the whole visa period. It is not optional, and letting it lapse can put your visa at risk.",
    },
    {
      q: "How much does OSHC cost?",
      a: "Premiums depend on the provider, the length of cover, and whether family members are included. Prices are set by the insurers and change, so we help you compare current options rather than quoting a fixed figure.",
    },
    {
      q: "Does it cover my family?",
      a: "If your partner or children are included on your student visa, they generally need to be covered too. We make sure the cover matches who is on your visa.",
    },
    {
      q: "What happens if I extend my studies?",
      a: "Your OSHC needs to extend to match your new visa period. We help you keep it current so there is no gap and no breach of your visa conditions.",
    },
  ],

  related: ["student-500", "admissions", "student-visa-extension"],

  lastVerified: "13 July 2026",
};

export default oshc;
